<div
  class="personal-form-view cbsw-personal-form-step"
  role="region"
  [attr.aria-label]="'Personal information form'"
  [attr.aria-live]="'polite'"
>
  @if (customerFormFieldsReady()) {
    <app-personal-form
      [customerRequiredFields]="customerRequiredFields"
      [requiredQuestionIds]="requiredQuestionIds"
      [customerReadonlyFields]="customerReadonlyFields"
      [customerPrefillValues]="customerPrefillValues"
      [showMeetingTypes]="showMeetingTypes"
      [selectedCustomFieldValues]="bookingService?.selectedBookingData?.selectedCustomFieldValues"
      [userInfo]="userInfo"
      [customerFormFields]="customerFormFields"
      [preResolvedQuestions]="bookingService.isAutoLoadInPersonalForm() ? bookingService.resolvedBookingQuestions() : []"
      [lockedZip]="lockedStorePostcode()"
      [meetingTypes]="meetingTypes"
      (submitEvent)="onSubmitEvent($event)"
      (previousEvent)="gotoPreviousPage()"
      [partnerData]="partnerData"
      role="form"
      [attr.aria-label]="'Personal information and meeting type selection'"
    />
  } @else {
    <!-- [auto_load_booking_questions_placement=personal_form] Waiting on whenAutoLoadSettled()
         before mounting app-personal-form — reuses the same global skeleton classes as
         booking-questions-view's loading state. -->
    <div class="skeleton-box-card mt-4" role="status" [attr.aria-label]="'Personal information form'" [attr.aria-busy]="true">
      <div class="row" role="list" [attr.aria-label]="'Loading personal form placeholders'">
        @for (ghost of customerFormFieldsGhostElements; track $index) {
          <div class="col-md-12" role="listitem">
            <div class="d-flex stats-card shadow" role="presentation" [attr.aria-hidden]="true">
              <div class="skeleton-animation w-100 d-flex justify-content-center flex-column gap-3">
                <div class="bar bar-1"></div>
                <div class="bar bar-2"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
